export const credential = {
  apiUrl:
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_API_URL
      : process.env.REACT_APP_API_URL_STAGE,
};
